import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import Link from "@mui/material/Link";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SmsIcon from "@mui/icons-material/Sms";
import SpaIcon from "@mui/icons-material/Spa";
import { Stack, Box, Typography, Grid, Container } from "@mui/material";
import getLPTheme from "../getLPTheme";

const App = ({ children, top }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const lightTheme = createTheme(getLPTheme("light"));

  return (
    <ThemeProvider theme={lightTheme} sx={{ height: "100%" }}>
      <Stack
        className="App"
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Box>{top}</Box>
        <Box
          sx={{
            overflowY: "auto",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ flexGrow: 1 }}>{children}</Box>
          <Box
            sx={{
              backgroundColor: "#f7f7f7",
              marginTop: "auto",
            }}
          >
            <Container
              maxWidth={"md"}
              sx={{
                pt: 3,
                pb: 2,
              }}
            >
              <Typography
                component={"span"}
                sx={{ fontSize: "8px", color: "gray", mr: "15px" }}
              >
                <span>&copy; 2026 Bim</span>
              </Typography>
              <Link
                sx={{
                  display: "inline-block",
                  mr: "15px",
                  fontSize: "8px",
                  textDecorationColor: "gray",
                  color: "gray",
                  "&:hover": { cursor: "pointer" },
                  "&::before": { backgroundColor: "gray", height: "1px" },
                }}
                href={"https://bimclinics.ru/policy"}
                target="_blank"
                rel="nofollow noopener"
              >
                Политика обработки персональных данных
              </Link>
              <Link
                sx={{
                  display: "inline-block",
                  mr: "15px",
                  fontSize: "8px",
                  textDecorationColor: "gray",
                  color: "gray",
                  "&:hover": { cursor: "pointer" },
                  "&::before": { backgroundColor: "gray", height: "1px" },
                }}
                href={"https://bimclinics.ru/consent"}
                target="_blank"
                rel="nofollow noopener"
              >
                Согласие на обработку персональных данных
              </Link>
              <Link
                sx={{
                  display: "inline-block",
                  mr: "15px",
                  fontSize: "8px",
                  textDecorationColor: "gray",
                  color: "gray",
                  "&:hover": { cursor: "pointer" },
                  "&::before": { backgroundColor: "gray", height: "1px" },
                }}
                href={"https://bimclinics.ru/offer"}
                target="_blank"
                rel="nofollow noopener"
              >
                Публичная оферта на оказание услуг массажа
              </Link>
              <Link
                sx={{
                  display: "inline-block",
                  mr: "15px",
                  fontSize: "8px",
                  textDecorationColor: "gray",
                  color: "gray",
                  "&:hover": { cursor: "pointer" },
                  "&::before": { backgroundColor: "gray", height: "1px" },
                }}
                href={"https://bimclinics.ru/pep"}
                target="_blank"
                rel="nofollow noopener"
              >
                Соглашение об использовании простой электронной подписи
              </Link>
              <Link
                sx={{
                  display: "inline-block",
                  mr: "15px",
                  fontSize: "8px",
                  textDecorationColor: "gray",
                  color: "gray",
                  "&:hover": { cursor: "pointer" },
                  "&::before": { backgroundColor: "gray", height: "1px" },
                }}
                href={"https://bimclinics.ru/pricing"}
                target="_blank"
                rel="nofollow noopener"
              >
                Стоимость услуг
              </Link>
            </Container>
          </Box>
        </Box>
      </Stack>
    </ThemeProvider>
  );
};

export default App;
